import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LoadingService {

	private loadingObj: any = {
		'total': 0,
		'loaded': 0,
		'percent': 0
	}; 

	private _isLoaded = new BehaviorSubject<boolean>(false);
	isLoaded = this._isLoaded.asObservable();

	public setIsLoaded(value: boolean) {
		this._isLoaded.next(value);
	}

	private _loadedImage = new BehaviorSubject<any>(this.loadingObj);
	loadedImage = this._loadedImage.asObservable();
	loadImages(imgArray: any) {
		let toObj = {
			'total': 0,
			'loaded': 0,
			'percent': 0
		}
		let base = this;
		var images = new Array()
		function preload(imgArray) {
			let progress = 100/imgArray.length;
			let totalLoaded = 0;
			let percent = 0;
			for (var i = 0; i < imgArray.length; i++) {
				images[i] = new Image()
				images[i].src = imgArray[i];

				images[i].onload = function(){
					//GOOD
					//setTimeout(() => {
						totalLoaded++;
						percent += progress;
						//base.percent += progress;
						
						toObj = {
							'total': imgArray.length,
							'loaded': totalLoaded,
							'percent': Math.round(percent)
						}
						//try this
						base._loadedImage.next(toObj);


						//if(totalLoaded == imgArray.length){
							//return 'All Loaded';
							/*setTimeout(() => {
								base.removeAnimations();
							}, 500);
							setTimeout(() => {
								base.isLoaded = true;	
								base.blockPosition();
							}, 1200)*/
							//}
							//}, 2300)

						};
					}
				}
				preload(imgArray);
			}
		}
